import { useEffect, useState } from "react";
import { toast } from "sonner";
import { format } from "date-fns";
import { ArrowLeftRight } from "lucide-react";
import api from "@/lib/api";
import { DeleteButton } from "@/components/DeleteButton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function AdminTransfers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/transfer/requests").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  async function del(id) {
    try { await api.delete(`/transfer/requests/${id}`); setItems((l) => l.filter((x) => x.id !== id)); toast.success("Transfer deleted."); }
    catch { toast.error("Failed to delete."); }
  }

  return (
    <div>
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary"><ArrowLeftRight className="h-6 w-6" /></div>
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Prescription Transfers</h1>
          <p className="text-sm text-muted-foreground">Transfer requests submitted by patients, including any attached insurance.</p>
        </div>
      </div>

      <div className="mt-6 overflow-hidden rounded-xl border border-border/60 bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Requested</TableHead><TableHead>Patient</TableHead><TableHead>DOB</TableHead><TableHead>Contact</TableHead>
              <TableHead>From Pharmacy</TableHead><TableHead>Insurance</TableHead><TableHead>Signature</TableHead><TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 ? (
              <TableRow><TableCell colSpan={8} className="py-10 text-center text-muted-foreground">No transfer requests yet.</TableCell></TableRow>
            ) : items.map((t) => (
              <TableRow key={t.id} data-testid={`transfer-row-${t.id}`}>
                <TableCell className="whitespace-nowrap text-sm">{format(new Date(t.created_at), "MMM d, h:mm a")}</TableCell>
                <TableCell className="font-medium">{t.first_name ? `${t.first_name} ${t.last_name || ""}`.trim() : t.name}</TableCell>
                <TableCell className="text-sm">{t.date_of_birth || "—"}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{t.phone}<br />{t.email}</TableCell>
                <TableCell>{t.current_pharmacy}</TableCell>
                <TableCell className="text-sm">
                  {t.insurance ? (
                    <div>
                      <Badge variant="outline">{t.insurance.insurance_name}</Badge>
                      <div className="mt-1 text-xs text-muted-foreground">ID {t.insurance.insurance_id} · BIN {t.insurance.bin_rx} · PCN {t.insurance.pcn} · GRP {t.insurance.grp_rx}</div>
                    </div>
                  ) : <span className="text-muted-foreground">—</span>}
                </TableCell>
                <TableCell>{t.signature ? <img src={t.signature} alt="signature" className="h-10 rounded border border-border bg-white" /> : "—"}</TableCell>
                <TableCell className="text-right"><DeleteButton onConfirm={() => del(t.id)} label="this transfer request" testId={`transfer-delete-${t.id}`} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
